import { useCallback, useEffect, useState } from "react";
import { BiHomeAlt, BiUser } from "react-icons/bi";
import { BsBriefcase, BsFillTelephoneFill } from "react-icons/bs";
import { Link } from "react-scroll";

const Nav = () => {
  const [activeLink, setActiveLink] = useState("home"); // Track current active section

  // Scroll handler using useCallback to prevent re-creation on every render
  const handleScroll = useCallback(() => {
    const sections = ["home", "about", "myExpertise", "projects", "contact"];
    const currentPosition = window.scrollY + 200; // offset for nav

    const active = sections.find((section) => {
      const element = document.getElementById(section);
      if (element) {
        const { offsetTop, offsetHeight } = element;
        return currentPosition >= offsetTop && currentPosition < offsetTop + offsetHeight;
      }
      return false;
    });

    if (active && activeLink !== active) {
      setActiveLink(active);
    }
  }, [activeLink]);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [handleScroll]); // now safe and ESLint-friendly

  // Navigation items data
  const navItems = [
    { id: "home", icon: <BiHomeAlt />, offset: -200, title: "Back to Home" },
    { id: "about", icon: <BiUser />, offset: -25, title: "About Me" },
    { id: "projects", icon: <BsBriefcase />, offset: 0, title: "My Projects" },
    { id: "contact", icon: <BsFillTelephoneFill />, offset: 0, title: "Contact Me" },
  ];

  return (
    <nav className="fixed bottom-2 lg:bottom-4 w-full overflow-hidden z-50">
      <div className="container mx-auto">
        <div className="w-full bg-black/20 h-[96px] backdrop-blur-2xl rounded-full max-w-[460px] mx-auto px-5 flex justify-between items-center text-2xl text-white/50">
          {navItems.map((item) => (
            <Link
              key={item.id}
              to={item.id}
              activeClass="active"
              smooth={true}
              spy={true}
              offset={item.offset}
              title={item.title}
              className={`cursor-pointer w-[60px] h-[60px] flex items-center justify-center ${
                activeLink === item.id ? "active text-accent" : ""
              }`}
              onClick={() => setActiveLink(item.id)}
            >
              {item.icon}
            </Link>
          ))}
        </div>
      </div>
    </nav>
  );
};

export default Nav;
